<template>
	<div class="video-listing-app row">
		<div data-scrollbottom-notif @click="scrollBottom"></div>
		<div class="show-for-medium medium-3 large-2 columns">
			<div data-abr-sticky class="directory-sticky-outer">
				<div class="inner">
					<category-selector :selected.sync="selectedCategory" :categories="categories"></category-selector>
				</div>
			</div>
		</div>
		<div class="small-12 medium-9 large-10 columns content-area">
			<div class="filter item show-for-medium">
				<select v-model="selectedYear">
					<option v-for="year in years" :value="year.value">
						{{ year.text }}
					</option>
				</select>
			</div>
			<div class="filter item show-for-medium">
				<select v-model="selectedMonth">
					<option v-for="month in months" :value="month.value">
						{{ month.text }}
					</option>
				</select>
			</div>
			<div class="filter item large-offset-4 show-for-medium">
				<select v-model="selectedSort">
					<option v-for="sort in sorts" :value="sort.value">
						{{ sort.text }}
					</option>
				</select>
			</div>
			<div class="item hide-for-medium">
				<div class="row">
					<div class="small-7 columns filter">
						<select v-model="selectedCategory">
							<option v-for="category in categories" :value="category.value">
								{{ category.text }}
							</option>
						</select>
					</div>
					<div class="small-5 columns filter">
						<a class="expanded small icon-button button" @click.prevent="mobileFilters = true">
							Filter
							<img v-icon.literal="filter.svg" alt="Filter" class="svg"/>
						</a>
					</div>
				</div>
			</div>
			<div class="item fast" v-for="video in videos" transition="motion-ui" enter-stagger="20" data-in="fade-in" data-out="fade-out">
				<video :video="video" :category-tid="selectedCategoryTid"></video>
			</div>
			<div class="loading-indicator fast" v-if="$loadingAsyncData" transition="motion-ui" data-in="fade-in">
				<div class="inner">
					<div class="ball-pulse-sync">
						<div></div>
						<div></div>
						<div></div>
					</div>
				</div>
			</div>
			<div class="empty-container fast text-center" v-if="videos.length <= 0 && !$loadingAsyncData" transition="motion-ui" data-in="fade-in">
				<div class="inner">
					<h1>No Videos Found</h1>
					<p>Looks like we couldn't find any videos matching your search. Please adjust your search or <a
						@click.prevent="startOver">start over.</a></p>
				</div>
			</div>
			<div class="empty-container small-margin fast text-center" v-if="disableScroll && videos.length > 0" transition="motion-ui" data-in="fade-in">
				<div class="inner">
					<h1>No More Results</h1>
					<p>We couldn't find any more videos matching your search. <a @click.prevent="startOver">Try another
						search?</a></p>
				</div>
			</div>
		</div>
		<div class="mobile-filters mobile-overlay" data-scroll-overlay :class="{ 'visible': mobileFilters }">
			<a class="close icon-button" @click.prevent="mobileFilters = false">
				<img v-icon.literal="close.svg" alt="Close" class="svg" />
			</a>
			<div class="wide list-container">
				<ul>
					<li>
						<div class="row">
							<div class="small-6 columns">
								<ul>
									<li class="label">Years</li>
									<li v-for="year in years" class="month" :class="{ 'is-active': selectedYear == year.value }">
										<a @click.prevent="selectYear(year.value)">
											{{ year.text }}
										</a>
									</li>
								</ul>
							</div>
							<div class="small-6 columns">
								<ul>
									<li class="label">Months</li>
									<li v-for="month in months" class="month" :class="{ 'is-active': selectedMonth == month.value }">
										<a @click.prevent="selectMonth(month.value)">
											{{ month.text }}
										</a>
									</li>
								</ul>
							</div>
						</div>
					</li>
					<li class="separator"></li>
					<li class="label">Sort</li>
					<li v-for="sort in sorts" :class="{ 'is-active': selectedSort == sort.value }">
						<a @click.prevent="selectSort(sort.value)">
							{{ sort.text }}
						</a>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
	import CategorySelector from './CategorySelector.vue'
	import Video from './Video.vue'
	import Videos from './../store/Videos'
	import deepClone from 'object-assign-deep'
	import _ from 'underscore'
	import qs from 'qs'
	import moment from 'moment'
	import Q from 'q'
	import Vue from 'vue'
	export default {
		components: { CategorySelector, Video },
		data() {

			// Get the categories from the Drupal settings.
			var categories_server = Object.values(window.Drupal.settings.abr_general.video_listing_categories);

			return deepClone({}, {
				sorts: [
					{ text: 'Newest-Oldest', value: 'desc' },
					{ text: 'Oldest-Newest', value: 'asc' }
				],
				videos: [],
				categoryLists: {
					'all': {
						arguments(category) {
							return {
								parameters: { category: 'all' }
							};
						}
					},
					'most-popular': {
						arguments(category) {
							return {
								parameters: { category: 'most-popular' }
							};
						}
					},
					'default': {
						arguments(category) {
							return {
								parameters: { category: category.tid }
							};
						}
					}
				},
				categories: [
					{ text: 'All Videos', value: 'all' },
					{ text: 'Most Popular', value: 'most-popular' }
				].concat(categories_server),
				disableWatch: false,
				page: 0,
				disableScroll: false,
				mobileFilters: false,
				selectedCategoryTid: false
			}, this.defaultFilters());
		},
		ready: function () {
			window.onpopstate = this.popState;
		},
		asyncData: function () {

			// Update the filter values.
			this.disableWatch = true;
			this.updateDataFilterValues();

			var self = this;

			// Prepare the arguments based on the selected filters.
			var filterArgs = { parameters: {}, pagesize: 30, page: this.page };
			var selectedCategoryInstance = self.categoryLists[this.selectedCategory] || self.categoryLists['default'];
			var selectedCategoryObject = _.findWhere(self.categories, { value: this.selectedCategory });
			this.selectedCategoryTid = selectedCategoryObject.tid;

			// Get the arguments for the selected category instance.
			filterArgs = deepClone(filterArgs, selectedCategoryInstance.arguments(selectedCategoryObject));

			// Prepare the filter arguments based on the rest of the filters.
			var time = null;
			if (this.selectedMonth !== 'all') {
				time = moment().month(this.selectedMonth).year(this.selectedYear);
				filterArgs['parameters']['created.ge'] = time.startOf('month').unix();
				filterArgs['parameters']['created.le'] = time.endOf('month').unix();
			} else if (this.selectedYear !== 'all') {
				time = moment().year(this.selectedYear);
				filterArgs['parameters']['created.ge'] = time.startOf('year').unix();
				filterArgs['parameters']['created.le'] = time.endOf('year').unix();
			}

			// Update the sort.
			filterArgs['sort'] = 'created';
			filterArgs['direction'] = this.selectedSort.toUpperCase();

			// Get the videos.
			return Videos.getInstance().fetch(filterArgs).then(function (videos) {
				self.videos = self.videos.concat(videos);
				if (videos.length < 30)
					self.disableScroll = true;
			}, function () {
				self.disableScroll = true;
			}).fin(function () {
				self.disableWatch = false;
			});

		},
		computed: {
			years() {
				var years = [
					{ value: 'all', text: 'All Years' }
				];
				var year = moment().year();
				for (var y = year - 5; y <= year; y++) {
					years.push({ text: y.toString(), value: y.toString() });
				}
				return years;
			},
			months() {
				var months = [
					{ text: 'All Months', value: 'all' }
				];
				for (var month = 0; month < 12; month++) {
					var monthName = moment().month(month).format('MMMM');
					months.push({ text: monthName, value: month.toString() });
				}
				return months;
			}
		},
		methods: {
			startOver: function () {

				var filters = this.defaultFilters();
				for (var key in filters) {
					if (!filters.hasOwnProperty(key)) continue;
					this.$set(key, filters[key]);
				}
				this.updateFilters();

				// Scroll the user to the top of the page.
				window.jQuery.scrollTo(0, { duration: 250 });

			},
			updateFilters: function () {

				// Don't update the filters if we've disabled watching.
				if (this.disableWatch) return;

				// Reset the page back to 0.
				this.page = 0;
				this.disableScroll = false;

				// Prepare the URL segments.
				var url_segments = [this.selectedCategory];
				if (this.selectedYear !== this.defaultFilters().selectedYear) {
					url_segments.push(this.selectedYear);
				}
				if (this.selectedMonth !== this.defaultFilters().selectedMonth) {
					if (this.selectedYear === this.defaultFilters().selectedYear)
						url_segments.push(moment().year().toString());
					url_segments.push(parseInt(this.selectedMonth, 10) + 1);
				}
				var url = '/videos/' + url_segments.join('/');

				// Prepare the query string.
				var search = '';
				if (this.selectedSort !== this.defaultFilters().selectedSort) {
					var query = {sort: this.selectedSort};
					search = '?' + qs.stringify(query);
				}

				// Add the new pushState.
				window.history.pushState(null, 'All Videos', url + search);

				// Clear the videos.
				this.videos = [];

				// Finally, trigger the AJAX refresh.
				this.reloadAsyncData();

			},
			popState: function () {

				this.videos = [];
				this.reloadAsyncData();

			},
			selectYear: function (year) {
				this.selectedYear = year;
			},
			selectMonth: function (month) {
				this.selectedMonth = month;
			},
			selectSort: function (sort) {
				this.selectedSort = sort;
			},
			updateDataFilterValues: function () {

				var filters = this.parseURLForFilters();
				for (var key in filters) {
					if (!filters.hasOwnProperty(key)) continue;
					this.$set(key, filters[key]);
				}

			},
			defaultFilters: function () {
				return {
					selectedYear: 'all',
					selectedMonth: 'all',
					selectedSort: 'desc',
					selectedCategory: 'most-popular'
				}
			},
			parseURLForFilters: function () {

				// First split the path segments to get the URL-based filters.
				var pathSegments = _.without(window.location.pathname.split('/'), '', 'videos');
				var filters = this.defaultFilters();
				if (pathSegments.length >= 1)
					filters.selectedCategory = this.validOrDefault('selectedCategory', pathSegments[0], this.categories);
				if (pathSegments.length >= 2)
					filters.selectedYear = this.validOrDefault('selectedYear', pathSegments[1], this.years);
				if (pathSegments.length >= 3)
					filters.selectedMonth = this.validOrDefault('selectedMonth', parseInt(pathSegments[2] - 1, 10).toString(), this.months);

				// Now parse the querystring to get the sort filter.
				var query = qs.parse(window.location.search.replace('?', ''));
				if (query['sort'])
					filters.selectedSort = this.validOrDefault('selectedSort', query['sort'], this.sorts);

				return filters;

			},
			validOrDefault: function (variable, value, options) {
				if (_.findWhere(options, { value: value }) === undefined)
					return this.defaultFilters()[variable];
				else return value;
			},
			scrollBottom: function () {
				if (this.$loadingAsyncData || this.disableScroll) return;
				this.page++;
				this.reloadAsyncData();
			},
			categoryChanged: function () {

				this.updateFilters();

				// Scroll the user to the top of the page.
				if (typeof(window.jQuery.scrollTo) !== 'undefined') {
					window.jQuery.scrollTo(0, {duration: 250});
				}

			}
		},
		watch: {
			selectedSort: 'updateFilters',
			selectedYear: 'updateFilters',
			selectedMonth: 'updateFilters',
			selectedCategory: 'categoryChanged',
			mobileFilters: function () {
				Vue.nextTick(function () {
					window.jQuery(document).trigger('scroll-overlay');
				});
			}
		}
	}
</script>



/** WEBPACK FOOTER **
 ** App.vue?c3974290
 **/